import React from 'react';
import PropTypes from 'prop-types';

const Customers = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='customers-title'>{altText}</title>
      <path fill='currentColor' fillRule='evenodd' d='M4.753 5.082a3.291 3.291 0 1 1 6.494 0l-.178 1.069a3.11 3.11 0 0 1-6.138 0l-.178-1.069ZM8 2.75a1.791 1.791 0 0 0-1.767 2.086l.178 1.068a1.61 1.61 0 0 0 3.178 0l.178-1.068A1.791 1.791 0 0 0 8 2.75ZM8.053 11.886a4.168 4.168 0 0 1 5.894 0l.053.053.053-.053a4.168 4.168 0 1 1 5.691 6.084l-4.262 3.73a2.25 2.25 0 0 1-2.964 0l-4.263-3.73a4.168 4.168 0 0 1-.202-6.084Zm4.833 1.061a2.668 2.668 0 1 0-3.643 3.894l4.263 3.73a.75.75 0 0 0 .988 0l4.263-3.73a2.668 2.668 0 1 0-3.643-3.894l-.584.583a.75.75 0 0 1-1.06 0l-.584-.583Z' clipRule='evenodd'/>
      <path fill='currentColor' d='M2.75 15A3.25 3.25 0 0 1 6 11.75a.75.75 0 0 0 0-1.5A4.75 4.75 0 0 0 1.25 15a.75.75 0 0 0 1.5 0Z'/>
    </svg>
  );
};

Customers.propTypes = {
  altText: PropTypes.string
};

export default Customers;
